import type { KnowledgeBase } from '@liks/backend-svc-api/esm/models/index';
import type {
  KnowledgeBaseWithIdentity,
  WithResourceId,
} from '../types/knowledge';

export function hasId<T extends { id?: string | null }>(
  value: T,
): value is WithResourceId<T> {
  return typeof value.id === 'string' && value.id.length > 0;
}

export function isAccessibleKnowledgeBase(
  knowledgeBase: KnowledgeBase,
): knowledgeBase is KnowledgeBaseWithIdentity {
  return (
    typeof knowledgeBase.id === 'string' &&
    knowledgeBase.id.length > 0 &&
    typeof knowledgeBase.name === 'string' &&
    knowledgeBase.name.length > 0
  );
}
